import React from "react";
import MainRouter from "./routers";

function App() {
  return (
    <div className="app">
      <MainRouter />
    </div>
  );
}

export default App;
